import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  IAuthTokensDto,
  ILanguageDto,
  ILlmConfigDto,
  ILlmModelsResponseDto,
  IUseOwnLlmDto,
} from '@shared';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { IGeminiKey } from '../../features/profile/models/gemini-key.model';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  #http = inject(HttpClient);

  refreshAccessToken(refreshToken: string): Observable<IAuthTokensDto> {
    return this.#http.post<IAuthTokensDto>(
      `${environment.apiUrl}/auth/refresh`,
      {
        refreshToken,
      },
    );
  }

  getGeminiKey(): Observable<IGeminiKey> {
    return this.#http.get<IGeminiKey>(`${environment.apiUrl}/me/gemini-key`);
  }

  updateGeminiKey(geminiApiKey: null | string): Observable<IGeminiKey> {
    return this.#http.patch<IGeminiKey>(`${environment.apiUrl}/me/gemini-key`, {
      geminiApiKey,
    });
  }

  updateLanguage(language: string): Observable<ILanguageDto> {
    return this.#http.patch<ILanguageDto>(`${environment.apiUrl}/me/language`, {
      language,
    });
  }

  getLlmConfig(): Observable<ILlmConfigDto> {
    return this.#http.get<ILlmConfigDto>(`${environment.apiUrl}/me/llm-config`);
  }

  updateLlmConfig(config: ILlmConfigDto): Observable<ILlmConfigDto> {
    return this.#http.patch<ILlmConfigDto>(
      `${environment.apiUrl}/me/llm-config`,
      config,
    );
  }

  getUseOwnLlm(): Observable<IUseOwnLlmDto> {
    return this.#http.get<IUseOwnLlmDto>(
      `${environment.apiUrl}/me/use-own-llm`,
    );
  }

  updateUseOwnLlm(useOwnLlm: boolean): Observable<IUseOwnLlmDto> {
    return this.#http.patch<IUseOwnLlmDto>(
      `${environment.apiUrl}/me/use-own-llm`,
      { useOwnLlm },
    );
  }

  getLlmModels(): Observable<ILlmModelsResponseDto> {
    return this.#http.get<ILlmModelsResponseDto>(
      `${environment.apiUrl}/me/llm-models`,
    );
  }
}
